<template>
	<div class="component avatar-cropper radius-small" v-cloak>
		<div class="avatar-container">
			<div class="uk-relative image-container uk-margin-auto uk-margin-bottom " style="max-width: 260px;">
				<div class="uk-border-rounded uk-overflow-hidden">
					<img :src="userAvatar" class="uk-width-1-1" ref="image" v-show="newAvatar == null">
					<img :src="newAvatar" ref="imagecropper" v-show="newAvatar != null">
				</div>
				<div class="button-container">
					<button class="uk-button uk-button-primary uk-width-1-1" v-on:click="selectImage" v-show="cropper == null">aanpassen</button>
					<button class="uk-button uk-button-seconday uk-width-1-2" v-on:click="cancel" v-show="cropper != null && !loading">annuleren</button>
					<button class="uk-button uk-button-primary uk-width-1-2" v-show="cropper != null && !loading" v-on:click="save">opslaan</button>
				</div>
			</div>
			<div v-show="loading" class="uk-flex uk-flex-center uk-margin-top width-1-1">
				<loading-indicator ></loading-indicator>
			</div>
			<form method="post" ref="avatarForm" enctype="multipart/form-data">
				<input type="hidden" :name="csrfName" :value="csrfToken">
				<input type="hidden" name="action" value="users/save-user">
				<input type="hidden" name="userId" :value="userId">
				<input type="file" name="photo" ref="fileInput" accept="image/x-png,image/jpeg" hidden />
			</form>
		</div>
	</div>
</template>

<script>

import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import axios from 'axios'
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'AvatarCropper',
	components: { LoadingIndicator },
	props: {
		userId: {
			type: Number,
			default: 0
		},
		currentAvatar: {
			type: String,
			required: false,
			default: null
		},
		defaultAvatar: {
			type: String,
			required: false,
			default() {
				// Genereer een unieke avatar gebaseerd op userId (of fallback op 'placeholder')
				const id = this?.userId || 'placeholder';
				return `https://robohash.org/${id}?set=set5`; // 'set5' is vaak gebruikt voor avatars
			}
		}
	},
	data() {
		return {
			loading: false,
			error: false,
			userAvatar: null,
			newAvatar: null,
			cropper: null,
			cropperOptions: {
				aspectRatio: 1,
				autoCropArea: 0.7,
				viewMode: 1
			},
			outputOptions: {}
		}
	},
	computed: {
		csrfName() {
			return window.csrfTokenName;
		},
		csrfToken() {
			return window.csrfTokenValue;
		},
		resolvedDefaultAvatar() {
			// Check of de meegegeven defaultAvatar een geldige URL is
			if (this.defaultAvatar && typeof this.defaultAvatar === 'string' && this.defaultAvatar.trim().startsWith('http')) {
				return this.defaultAvatar;
			}
			// Fallback naar Robohash
			const id = this.userId || 'placeholder';
			return `https://robohash.org/${id}?set=set5`;
		},
	},
	created() {
		var component = this;
		component.$logger('Vue/components/avatar-cropper/created');
	},
	mounted() {
		var component = this;
	
		component.userAvatar = component.currentAvatar || component.resolvedDefaultAvatar;

		var fileInput = this.$refs.fileInput;
	
		fileInput.addEventListener('change', function(e) {
			var reader = new FileReader();
			reader.onload = function(e) {
	
				component.newAvatar = e.target.result;
	
				// Timeout, so we're ready to init the cropper
				setTimeout(function() {
					component.cropper = new Cropper(component.$refs.imagecropper, component.cropperOptions);
				},50);
			}
			reader.readAsDataURL(fileInput.files[0]);
		});
	},
	methods: {
		selectImage(e) {
			this.$refs.fileInput.click();
			e.preventDefault();
			e.stopPropagation();
		},
		cancel() {
			var component = this;
			component.cropper.destroy();
			component.cropper = null;
			component.newAvatar = null;
			component.error = false;
		},
		save() {
			var component = this;

			component.$logger('Vue/components/avatar-cropper/save');
			component.loading = true;

			var newAvatar = component.cropper.getCroppedCanvas(component.outputOptions).toDataURL();
			component.cropper.getCroppedCanvas(component.outputOptions).toBlob((blob) => {
				var form = component.$refs.avatarForm;
				var formData = new FormData(form);
				var ts = new Date().getTime();
				formData.append('photo', blob, 'avatar_' + ts + '.jpg');
				axios({
					method: 'post',
					url: '/',
					responseType: 'json',
					data: formData,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Accept': 'application/json'
					}
				})
					.then(function(response) {
						component.$logger('Vue/components/avatar-cropper/response');
						component.$logger(response);
						if (response && response.data && response.data.id > 0) {
							component.userAvatar = newAvatar;
						}
						component.loading = false;
						setTimeout(function() {
							component.cancel();
						}, 50);
					})
					.catch(function(e) {
						console.error(e);
						component.loading = false;
						component.cancel();
					});
			});
		}
	}
}
</script>
